module.exports = __webpack_public_path__ + "~@/assets/img/ipconfig_splash.95fcc727.png";